import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { EventPrivacyMode } from '../../models/serializable/event-privacy-mode.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class EventPrivacySettingsComponent extends Component {
  static readonly TYPE_ID: string = '707b4d61272448b5930800228a9bc16e';

  constructor(
    public readonly privacyMode: EventPrivacyMode,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return EventPrivacySettingsComponent.TYPE_ID;
  }

  static fromMap(context:SerializationContext, map: SerializedData): EventPrivacySettingsComponent {
    return new EventPrivacySettingsComponent(
        toEnumFromString(MapUtils.get<string>(map, 'privacyMode'), EventPrivacyMode),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'privacyMode': fromEnumAsString(this.privacyMode),
    };
  }

  clone(): this {
    return new EventPrivacySettingsComponent(
        this.privacyMode,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.privacyMode === this.privacyMode;
  }
}

export class EventPrivacySettingsComponentBuilder extends DataModelBuilder<EventPrivacySettingsComponent> {
  build(context: SerializationContext, map: SerializedData): EventPrivacySettingsComponent {
    return EventPrivacySettingsComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    this.migrateEnum(map, 'privacyMode', EventPrivacyMode, EventPrivacyMode.Private);

    return map;
  }
}
